import React, { useState } from "react";
import searchError from '../../../../src/images/searchError.svg';
import './styles.css';
import TablePagination from "../../../components/common/tablePagination";

const Competitor = ({getBenchMarkData = {}}) => {
  const [pageNum, setPageNum] = useState(1);
  const [paginationLimit, setPaginationLimit] = useState(10);

  const onPageNumClick = (page) => {
    setPageNum(page);
    };

    const onPrevClick = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setPageNum((prevPageNum) => prevPageNum - 1);
    };
  
    const onNextClick = () => {
      if(Object.keys(getBenchMarkData).length > 0) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        // if ((getBenchMarkData["bench-marking-data"]) && Boolean((getBenchMarkData["bench-marking-data"]).length) > pageNum * paginationLimit) {
          setPageNum((prevPageNum) => prevPageNum + 1);
       // }
      } 
    };
  const transformLabel = (label) => {
    let data =  label
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

      if (!data.endsWith("Deal")) {
        data += " Deal";
      }
      if(data === 'Flat Deal') {
        data = 'Custom Deal';
      }
      return data;
  };

  function replaceRsWithRupeeSymbol(data) {
    if (typeof data !== 'string') {
      return data;
    }
    return data.replace(/Rs./g, '₹');
  }
  

    return (Object.keys(getBenchMarkData).length === 0 ? <div className="searchBlck">
       <img src={searchError} className="searchError" alt="searchError" />
       <div className="displayText">Search for specific route</div>
       <div className="displayData">Enter a specific source and destination 
       to find the deals and discounts offered by the competitors</div>
    </div> : <div>
    <div className="benchContainer">
      <div className="bench">Operator Name</div> 
      <div className="bench">Deal Name</div>  
      <div className="bench">Deal Type</div>  
    </div>
    <div className="benchBottomBorder"></div>
    {(getBenchMarkData["bench-marking-data"]).slice(
                      (pageNum - 1) * paginationLimit,
                      pageNum * paginationLimit
                    ).map((elem, index) => {
        return (<div className="benchMark" key={index}>
          <div className="benchData">{elem.operator_name}</div> 
          <div className="benchData">{replaceRsWithRupeeSymbol(elem.deal_name)}</div>  
          <div>{transformLabel(elem.deal_type)}</div>  
        </div>)
    })}
    {(getBenchMarkData["bench-marking-data"]) && Boolean((getBenchMarkData["bench-marking-data"]).length) && ((getBenchMarkData["bench-marking-data"]).length)>10 && (
              <div className="pagination">
                <TablePagination
                  pageNum={pageNum}
                  dataLength={(getBenchMarkData["bench-marking-data"]) && (getBenchMarkData["bench-marking-data"]).length}
                  onPrevClick={onPrevClick}
                  onNextClick={onNextClick}
                  isInventoryView={true}
                  paginationLimit={paginationLimit}
                  onPageNumClick={onPageNumClick} 
                  dealPagination              
                />
              </div>
            )} 
    </div>)
}

export default Competitor